"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnmanagedTooltipIcon_1 = require("../UnmanagedTooltipIcon");
var ManagedOpenableComponent_1 = require("../../utils/hoc/ManagedOpenableComponent");
/**
 * This component does provide an icon with a tooltip. The tooltip is
 * opened and closed by clicking on the icon.
 *
 * On large screens the tooltip will be displayed right beneath the icon
 * in form of a well known tooltip.
 *
 * On small screens the tooltip will open as an overlay over the complete
 * page.
 *
 * The tooltip does contain a close button, that will close the tooltip.
 *
 * The content of the tooltip is defined by the children of this component.
 *
 * Only one single tooltip is allowed to be opened at once. If the user
 * does open a tooltip, while another tooltip is already opened, the first
 * tooltip will be closed and the new tooltip will be opened. The open state
 * checks are executed application wide, which means tooltips of other
 * providers will also be closed.
 */
exports.TooltipIcon = ManagedOpenableComponent_1.withManagedIsOpenState(UnmanagedTooltipIcon_1.UnmanagedTooltipIcon, true, 'ee_tooltip-wrapper');
exports.TooltipIcon.displayName = 'TooltipIcon';
exports.default = exports.TooltipIcon;
//# sourceMappingURL=TooltipIcon.js.map